export default {
    partnerships: {
        eyebrow: '合作夥伴',
        heading: '與 NobleWills 攜手，拓展您的客戶服務版圖',
        intro: '我們為顧問、保險公司、企業及各類客戶導向團隊提供靈活的合作模式，讓更廣泛的客戶群受惠於專業的遺產規劃支援。',
        primaryCta: '聯絡我們',
        secondaryCta: '關於我們',
        solutionsHeading: '合作模式',
        solutionsIntro: '按照您的客戶結構、工作流程及參與程度，揀選最合適的合作方式。',
        whyWorkWithUsHeading: '為何選擇 NobleWills 作為合作夥伴',
        whyWorkWithUsIntro:
            '我們致力協助機構輕鬆為其客戶、員工或會員提供優質的遺產規劃服務。透過專業指引、現代化科技及高效率的夥伴支援，讓您無需增加團隊營運負擔，即可為服務增值。',
        whyMultiWillsTitle: '多元遺囑方案，涵蓋不同人生階段',
        whyMultiWillsBody: '提供多種遺囑格式及規劃選項，因應客戶的個別狀況與家庭結構作出配合，而非採用單一標準化模板。',
        whyCrossBorderTitle: '跨境資產規劃實力',
        whyCrossBorderBody: '針對跨司法管轄區及多地資產配置的需求，提供清晰的流程與規劃支援，照顧跨境家庭及國際專業人士的實際情況。',
        whySpecialistsTitle: '專業遺產規劃支援',
        whySpecialistsBody:
            '我們的團隊擅長處理涉及多個司法管轄區、多元資產類別及複雜家庭結構的遺產規劃。我們結合理論知識與實務經驗，配合清晰有序的流程，協助客戶更有信心地作出明智決策。',
        whyTrustedTitle: '獲法律專業人士信賴',
        whyTrustedBody: '我們與法律從業員緊密合作，並堅持嚴謹的品質標準，讓您可安心將我們的服務推薦予您的客戶。',
        whySupportTitle: '為團隊及客戶締造流暢體驗',
        whySupportBody:
            '我們的服務不僅面向個別客戶，更以合作夥伴為核心。從夥伴導入、客戶教育、平台操作到文件交付，我們致力簡化流程、迅速回應查詢，確保每個環節均維持專業一致的水準。',
        whyFlexibleTitle: '合作模式靈活配合您的業務需要',
        whyFlexibleBody:
            '無論您傾向簡單轉介、聯名推廣頁面、顧問主導的客戶導入、員工福利計劃，或更深度的服務整合，我們均可根據您的團隊規模、品牌定位及客戶體驗需求，靈活調整合作方式。',
        seamlessTitle: '無縫系統整合',
        seamlessBody: '將 NobleWills 整合至您現有的服務流程，讓客戶可從您的平台直接進入引導式遺產規劃體驗，無需額外跳轉。',
        seamlessIdealFor: '適用於：希望將遺產規劃支援整合至產品服務流程的手機應用程式或網頁平台。',
        affiliateStandardTitle: '標準聯盟計劃',
        affiliateStandardBody: '開放予所有人士參與的聯盟計劃，透過轉介客戶賺取佣金回報。',
        affiliateStandardIdealFor: '適用於：內容創作者、社群經營者及個人推薦者。',
        affiliateBrandedTitle: '品牌聯盟計劃',
        affiliateTitle: '聯盟合作計劃',
        affiliateBody: '透過聯名推廣頁面轉介客戶，進一步鞏固信任，同時確保客戶體驗連貫一致。',
        affiliateBrandedIdealFor: '適用於：希望為其受眾提供品牌化合作體驗的企業或團隊。',
        dashboardTitle: '代理人儀表板',
        dashboardBody: '讓代理人及經理可透過專為輔助完成而設的工作流程，協助客戶建立所需文件。',
        dashboardIdealFor: '適用於：需要管理客戶資料的理財經理或保險代理。',
        corporateTitle: '企業方案',
        corporateBody: '為企業度身訂造的合作方案，將遺產規劃納入員工福利或客戶服務範疇，並涵蓋教育講座及團體優惠定價。',
        corporateIdealFor: '適用於：人力資源團隊、員工福利供應商及專業協會。',
        eventsTitle: '合辦活動',
        eventsBody: '攜手舉辦教育講座及推廣活動，建立信任、發掘潛在客戶，並將興趣轉化為實際行動。',
        customTitle: '自訂方案',
        customBody: '若標準模式未能完全滿足需求，我們可按您的受眾特性、營運流程或分銷策略，設計專屬的合作方式。',
        customIdealFor: '適用於：有獨特整合或營運需求的策略合作夥伴。',
        benefitHeading: '締造雙贏，共享價值',
        benefitBody: '所有合作模式均支援自動套用的客戶折扣及合作夥伴轉介費機制，確保雙方的價值交換由始至終清晰透明。',
        contactHeading: '準備好探索合作可能性？',
        contactBody: '請告知我們您的受眾、團隊規模或推廣目標，我們將協助您規劃最合適的合作路徑。',
    },
};
